import type { ImportWarning, ImportWarningCode } from '@bits2schema/shared';
import { useT } from '../i18n';
import type { MessageKey } from '../i18n/types';

const WARNING_KEYS: Record<ImportWarningCode, MessageKey> = {
  unknownType: 'warnings.code.unknownType',
  permissionDenied: 'warnings.code.permissionDenied',
  tableSkipped: 'warnings.code.tableSkipped',
  indexNotRepresentable: 'warnings.code.indexNotRepresentable',
  constraintNotRepresentable: 'warnings.code.constraintNotRepresentable',
  metadataQueryFailed: 'warnings.code.metadataQueryFailed',
};

/** E1-US5 — souhrn dílčích problémů importu. */
export function ImportWarnings({ warnings }: { warnings: ImportWarning[] }) {
  const t = useT();

  if (warnings.length === 0) {
    return <p className="hint">{t('warnings.none')}</p>;
  }

  return (
    <div className="stack">
      <div className="notice notice--warning">{t('warnings.count', { count: warnings.length })}</div>
      <table>
        <thead>
          <tr>
            <th>{t('warnings.column.location')}</th>
            <th>{t('warnings.column.message')}</th>
          </tr>
        </thead>
        <tbody>
          {warnings.map((warning, index) => (
            <tr key={`${warning.code}-${index}`}>
              <td>
                <span className="badge">{t(WARNING_KEYS[warning.code] ?? 'error.internalError')}</span>
                <div className="hint">{formatLocation(warning)}</div>
              </td>
              <td>{warning.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Názvy objektů z DB se nepřekládají — skládají se jen do cesty schema.table.column. */
function formatLocation(warning: ImportWarning): string {
  return [warning.schema, warning.table, warning.column].filter(Boolean).join('.');
}
